__turbopack_context__.v({
  "slick-active": "slick-theme-module-scss-module__b82cqq__slick-active",
  "slick-disabled": "slick-theme-module-scss-module__b82cqq__slick-disabled",
  "slick-dots": "slick-theme-module-scss-module__b82cqq__slick-dots",
  "slick-dotted": "slick-theme-module-scss-module__b82cqq__slick-dotted",
  "slick-next": "slick-theme-module-scss-module__b82cqq__slick-next",
  "slick-prev": "slick-theme-module-scss-module__b82cqq__slick-prev",
  "slick-slider": "slick-theme-module-scss-module__b82cqq__slick-slider",
});
